import React, { memo } from 'react';
import PropTypes from 'prop-types';

import {
  CheckIcon,
  FinawardsIcon,
  ProductAdvantage,
  ProductAdvantagesList,
  ProductAdvantagesWrapper,
} from './ProductAdvantages.styles';

const MAP_CODE_TO_ICON = {
  fa: 'original',
  ga: 'gold',
  sa: 'silver',
  ba: 'bronze',
};

const handleIconCode = (title) => {
  const iconCodeRegExp = / (fa|ga|sa|ba)$/;

  if (iconCodeRegExp.test(title)) {
    const code = title.match(iconCodeRegExp)[1];
    const titleWithoutCode = title.replace(iconCodeRegExp, '');

    return (
      <>
        {titleWithoutCode}
        <FinawardsIcon name={MAP_CODE_TO_ICON[code]} />
      </>
    );
  }

  return title;
};

function ProductAdvantages({ advantages = [] }) {
  return (
    <ProductAdvantagesWrapper>
      <ProductAdvantagesList>
        {advantages.map((advantage) => (
          <ProductAdvantage key={advantage.title}>
            <CheckIcon />

            {handleIconCode(advantage.title)}
          </ProductAdvantage>
        ))}
      </ProductAdvantagesList>
    </ProductAdvantagesWrapper>
  );
}

ProductAdvantages.propTypes = {
  advantages: PropTypes.arrayOf(
    PropTypes.shape({ title: PropTypes.string }).isRequired
  ),
};

export default memo(ProductAdvantages);
